export const addIfNotIncluded = (array, item) =>
  array.includes(item) || !item ? array : [...array, item];
